export enum ImgRatio {
    Bigger = 1,
    Equal
}